import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Chat, ChatApp } from "../../../../utils/Constant";
import ChatStatus from "../VideoChat/ChatStatus/ChatStatus";
import UserChatting from "./UserChatting";
import { useAppDispatch } from "../../../../ReaduxToolkit/Hooks";
import axios from "axios";
import { setAllMembers, setChats } from "../../../../ReaduxToolkit/Reducer/ChatSlice";
import { useEffect } from "react";
import webservice from '../../../../Service/webservice';
import api from '../../../../api';


const Chating = () => {
 const dispatch = useAppDispatch();
  const getChatMembersData = async () => {
    try {
      const response = await api.fetch('api/Chat/getUsers', { method: 'GET' });
      const data = await response.json();
      dispatch(setAllMembers(data));
    } catch (error) {
      console.log("error", error);
    }
  };

  const getChatData = async () => {
    try {
      const response = await api.fetch('api/Chat/getUsersData', { method: 'GET' });
      const data = await response.json();
      dispatch(setChats(data));
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getChatData();
    getChatMembersData();
  }, []);

  return (
    <>
      <Breadcrumbs mainTitle={ChatApp} parent={Chat} title={ChatApp} />
      <Container fluid>
        <Row>
          <Col sm="12" className="call-chat-sidebar">
            <Card>
              <CardBody className="chat-body">
                <ChatStatus />
              </CardBody>
            </Card>
          </Col>
          <Col className="call-chat-body">
            <Card>
              <CardBody className="p-0">
                <UserChatting />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Chating;
